import Model from "~/models/eschoolplus/scheduling/Section";
import Recommendation from "./Recommendation";

export default class Section extends Model {
  // Define a base url for a REST API
  baseURL() {
    return useRuntimeConfig().public.apiBase + "/api/v2/courserecommendations";
  }

  // Set the resource route of the model
  resource() {
    return "sections";
  }

  relations() {
    return {
      student_recommendations: Recommendation,
      student_recommendations_finalized: Recommendation,
    };
  }

  // Computed Attributes
  get display_course() {
    return this.COURSE.trim();
  }

  get display_course_section() {
    return `${this.COURSE.trim()}-${this.COURSE_SECTION}`;
  }

  get display_course_description() {
    return `${this.COURSE.trim()}: ${this.DESCRIPTION_CLEAN}`;
  }

  get display_block_type() {
    switch (this.BLOCK_TYPE) {
      case "B":
        return "Block";
      case "C":
        return "Blockette";
      case "N":
        return "Standalone";
    }
    return "Unknown Course Block Type";
  }

  get display_course_rec_status() {
    if (!this.student_recommendations_count) {
      return "Unknown";
    }

    if (
      this.student_recommendations_finalized_count >=
      this.student_recommendations_count
    ) {
      return "Completed";
    } else if (this.student_recommendations_finalized_count == 0) {
      return "Not Started";
    }

    return "Incomplete";
  }

  get display_marking_period() {
    if (!this.marking_periods) {
      return "";
    }
    const mps = [];
    this.marking_periods.forEach((mp) => {
      mps.push(mp.MARKING_PERIOD.trim());
    });
    return mps.join(", ");
  }
}
